// React core.
import React from 'react';
//import ReactDOM from 'react-dom';

import config from 'react-global-configuration';

// Firebase.
import firebase from './../Firestore'
import 'firebase/auth';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';

// Styles
import styles from './css/app.css'; // This uses CSS modules.
//import './css/firebaseui-styling.global.css'; // Import globally.

import { Link } from 'react-router-dom';

//import store from '../../store';

// Get the Firebase config from the auto generated file.
//const firebaseConfig = require('../../firebase.json').result;

// Instantiate a Firebase app.
//const firebaseApp = firebase.initializeApp(config);

/**
 * The Splash Page containing the login UI.
 */
class Login extends React.Component {
  uiConfig = {
    signInFlow: 'popup',
    signInOptions: [
      firebase.auth.EmailAuthProvider.PROVIDER_ID,
    ],
    callbacks: {
      signInSuccessWithAuthResult: () => this.props.history.push("/admin/pedidos"),
    },
  };

  state = {
    isSignedIn: undefined,
  };

  /**
   * @inheritDoc
   */
  async componentDidMount(prevState) {

      this.unregisterAuthObserver = await firebase.auth().onAuthStateChanged((user) => {
        this.setState({isSignedIn: !!user});
        let esAdministrador = config.get('admin').indexOf(firebase.auth().currentUser.email);
        if (esAdministrador < 0) firebase.auth().signOut()
      });


  }

  /**
   * @inheritDoc
   */
  componentWillUnmount() {
    this.unregisterAuthObserver();
  }

  /**
   * @inheritDoc
   */
  render() {

    return (
      <div className="containerLogin">
        {this.state.isSignedIn !== undefined && !this.state.isSignedIn &&
          <div>
            <StyledFirebaseAuth className={styles.firebaseUi} uiConfig={this.uiConfig}
                                firebaseAuth={firebase.auth()}/>
          </div>
        }
        {this.state.isSignedIn &&
          <div className="bg-light text-dark p-2">

            Hola {firebase.auth().currentUser.displayName}.<br />
            Ingresaste como administrador de la App {config.get('tienda').nombre}!<br />
            <div className="mt-3 align-middle text-center">
            <Link to="/admin/pedidos" className="m-2 btn btn-primary">ver Pedidos</Link>
            <Link to="/admin/" className="m-2 btn btn-primary">ver Productos</Link>
            <i className="m-2 fas fa-sign-out-alt fa-3x text-primary align-middle" onClick={() => firebase.auth().signOut()}></i>
            </div>
          </div>
        }
      </div>
    );
  }
}

export default Login;

// Load the app in the browser.
//ReactDOM.render(<App/>, document.getElementById('app'));
